module.exports = __webpack_public_path__ + "media/images/interests/relationship-b2c6efdb1a2612b80714f69fd6746dfa.png";